import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import BreakCategoryEditor from 'components/forms/CustomFields/BreakCategoriesEditor';
import {createResourceTypeSelector} from "resources/selectors";

const getCategoryItems = createResourceTypeSelector(ResourceApi.Types.Category);

const mapStateToProps = (state) => {

    let categories = getCategoryItems(state.resources).filter((item) => {
        console.log(`item`, item)
        return item.siteId === "d13a8764-6797-498b-8c8c-5c1808787bd9"   // dailybreak.com
    })
    return {
        categories: categories
    }
};

const mapDispatchToProps = (dispatch) => ({
    getCategories: () => dispatch(getAllResourcesAction(ResourceApi.Types.Category, sortOptionsFactory(), filterOptionsFactory()))
});

const BreakCategoryEditorConnected = connect(mapStateToProps, mapDispatchToProps);

const BreakCategoryLifecycle = lifecycle({
    componentDidMount: function() {
        this.props.getCategories();
    }
});

const BreakCategoryEditorComposed = compose(
    BreakCategoryEditorConnected,
    BreakCategoryLifecycle
)(BreakCategoryEditor);

export default BreakCategoryEditorComposed



// WEBPACK FOOTER //
// ./public/components/composites/BreakCategoriesEditorConnected.jsx